import { render, staticRenderFns } from "./buyAlbum.vue?vue&type=template&id=bd9942f4&scoped=true&"
import script from "./buyAlbum.vue?vue&type=script&lang=ts&"
export * from "./buyAlbum.vue?vue&type=script&lang=ts&"
import style0 from "./buyAlbum.vue?vue&type=style&index=0&id=bd9942f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd9942f4",
  null
  
)

export default component.exports